module.exports = __webpack_public_path__ + "img/tik-tok_3046133.9f4254d1.png";